import React from 'react';
import { LinearProgress as MuiLinearProgress } from '@mui/material';
import { variantMapping } from './variants';

const CustomLinearProgress = ({ value, variantCustom, ...props }) => (
  <MuiLinearProgress
    value={value}
    {...props}
    sx={{
      height: variantMapping[variantCustom].height,
      borderRadius: variantMapping[variantCustom].borderRadius,
      backgroundColor: variantMapping[variantCustom].backgroundColor,
      '& .MuiLinearProgress-bar': {
        backgroundColor: variantMapping[variantCustom].barColor,
        borderRadius: variantMapping[variantCustom].barBorderRadius,
      },
      ...props.sx,
    }}
  />
);

export default CustomLinearProgress;
